import { Suspense, memo, type ComponentProps } from 'react';
import { Skeleton, SkeletonProps } from 'antd';
import ErrorBoundary from 'components/ErrorBoundary';
import { lazyImport, type LazySvgProps } from './utils';

/* Icon skeleton component */
function IconSkeleton(props: SkeletonProps) {
  return <Skeleton.Avatar size='large' shape='circle' {...props} />;
}
export const MemoizedIconSkeleton = memo(IconSkeleton);

// Decorative unless the caller names it; a named svg is exposed as an image. Clickable svgs are left as-is.
function getA11yProps(props: ComponentProps<'svg'>): ComponentProps<'svg'> {
  if (props['aria-label'] || props['aria-labelledby'] || props.role) {
    return { role: 'img' };
  }
  if (props.onClick) return {};
  return { 'aria-hidden': true, focusable: false };
}

function LazySvg({
  name,
  subFolder,
  qaSelector,
  fallback = <MemoizedIconSkeleton active />,
  ...rest
}: LazySvgProps) {
  const LazyIcon = lazyImport({ name, subFolder });
  const a11yProps = getA11yProps(rest);

  return (
    <ErrorBoundary fallback={fallback}>
      <Suspense fallback={fallback}>
        <LazyIcon data-qa-selector={qaSelector} {...a11yProps} {...rest} />
      </Suspense>
    </ErrorBoundary>
  );
}

export default memo(LazySvg);
